const cs = {
  pleaseEnterUsername: "Zadejte uživatelské jméno",
  cannotFriendYourself: "Nemůžete poslat žádost o přátelství sami sobě.",
  friendRequestSent: "Žádost o přátelství byla odeslána!",
  failedToSendRequest: "Nepodařilo se odeslat žádost",
  linkCopied: "Odkaz byl zkopírován do schránky!",
  backToInvites: "Zpět na pozvánky",
  sendFriendRequestByUsername: "Odeslat žádost o přátelství pomocí uživatelského jména",
  enterUsername: "Zadejte uživatelské jméno",
  send: "Odeslat",
  yourInviteQrCode: "Váš QR kód pozvánky",
  inviteLink: "Odkaz na pozvánku",
  scanQrOrUseLink: "Naskenujte tento QR kód nebo použijte tento odkaz k odeslání žádosti o přátelství",
  copyInviteLink: "Kopírovat odkaz na pozvánku",
  goToItem: "Přejít na položku",
  verificationEmailSent: "Ověřovací e-mail byl odeslán! Zkontrolujte svou schránku.",
  verificationEmailFailed: "Nepodařilo se odeslat ověřovací e-mail. Zkuste to znovu.",
  verifyYourEmail: "Ověřte svůj e-mail",
  verifyEmailInstructions: "Pro přístup ke svému účtu ověřte svou e-mailovou adresu. Ve schránce najdete ověřovací odkaz.",
  sending: "Odesílání...",
  resendVerificationEmail: "Znovu odeslat ověřovací e-mail",
  login: "Přihlásit se",
  register: "Registrovat se",
  home: "Domů",
  calendar: "Kalendář",
  friends: "Přátelé",
  profile: "Profil",
  logout: "Odhlásit se",
  loading: "Načítání...",
  language: "Jazyk",
  calendarSelectPlaceSuggestion: "Vyberte místo z návrhů, aby byly připojeny souřadnice.",
  calendarSelectDateAndTime: "Vyberte datum a čas.",
  calendarPositiveDuration: "Zadejte kladnou dobu trvání.",
  calendarFutureDateRequired: "Datum a čas události musí být v budoucnosti.",
  calendarCreateEventFailed: "Nepodařilo se vytvořit událost. Zkuste to znovu.",
  cancel: "Zrušit",
  createNewEvent: "Vytvořit novou událost",
  week: "Týden",
  month: "Měsíc",
  eventTitle: "Název",
  date: "Datum",
  time: "Čas",
  duration: "Délka trvání",
  endsAt: "Končí v",
  place: "Místo",
  searchForPlace: "Vyhledat místo",
  placeSearchTip: "Tip: začněte psát a vyberte výsledek pro připojení souřadnic.",
  description: "Popis",
  createEvent: "Vytvořit událost",
  today: "Dnes",
  previousMonth: "Předchozí měsíc",
  nextMonth: "Další měsíc",
  previous: "Předchozí",
  next: "Další",
  mondayShort: "Po",
  tuesdayShort: "Út",
  wednesdayShort: "St",
  thursdayShort: "Čt",
  fridayShort: "Pá",
  saturdayShort: "So",
  sundayShort: "Ne",
  more: "více",
  mustRespondWillBeforeReposting: "Před sdílením musíte odpovědět „Zúčastním se“",
  event: "Událost",
  backToCalendar: "Zpět do kalendáře",
  addToGoogleCalendar: "Přidat do Kalendáře Google",
  when: "Kdy",
  where: "Kde",
  openLocationInGoogleMaps: "Otevřít polohu v Mapách Google",
  hosts: "Pořadatelé",
  yourResponse: "Vaše odpověď",
  currentResponse: "Aktuální odpověď",
  response_will: "Zúčastním se",
  response_might: "Možná se zúčastním",
  response_wont: "Nezúčastním se",
  willRunIntoYou: "Zastavím se",
  mightDropBy: "Možná se zastavím",
  wontCome: "Nepřijdu",
  repostToMyFriends: "Sdílet přátelům",
  responses: "Odpovědi",
  willAttend: "Zúčastní se",
  reposted: "Sdíleno",
  mightAttend: "Možná se zúčastní",
  cancelEvent: "Zrušit událost",
  cancellationEmailNoticeBefore: "Účastníci, kteří potvrdili účast,",
  cancellationEmailNoticeAfter: "budou informováni e-mailem o zrušení.",
  optionalCancellationMessage: "Volitelná zpráva účastníkům (max. 1000 znaků)",
  confirmCancelEvent: "Potvrdit zrušení události",
  clear: "Vymazat",
  confirmCancellation: "Potvrdit zrušení",
  confirmCancellationMessage: "Opravdu chcete tuto událost zrušit? Potvrzení účastníci budou informováni a událost bude odstraněna.",
  eventCancelledNotified: "Událost byla zrušena. Informováno",
  attendees: "účastníků",
  failedToCancelEvent: "Nepodařilo se zrušit událost",
  back: "Zpět",
  cancelled: "Zrušeno",
  ok: "OK",
  forgotPassword: "Zapomenuté heslo",
  email: "E-mail",
  passwordResetLinkSent: "Pokud účet existuje, byl odeslán odkaz pro reset hesla.",
  passwordResetRequestFailed: "Nepodařilo se požádat o reset hesla.",
  sendResetLink: "Odeslat odkaz pro reset",
  addFriend: "Přidat přítele",
  incomingRequests: "Příchozí žádosti",
  accept: "Přijmout",
  deny: "Odmítnout",
  myFriends: "Moji přátelé",
  noFriendsYet: "Zatím nemáte žádné přátele. Začněte si nějaké přidávat!",
  seeProfile: "Zobrazit profil",
  noEventsToRespondTo: "Žádné události k odpovědi",
  allCaughtUp: "Máte vše vyřízené. Vraťte se později pro nové události od přátel.",
  events: "Události",
  unknown: "Neznámé",
  noDescriptionProvided: "Nebyl poskytnut žádný popis.",
  will: "Ano",
  maybe: "Možná",
  wont: "Ne",
  userNotFound: "Uživatel nebyl nalezen",
  friendRequestSentSuccessfully: "Žádost o přátelství byla úspěšně odeslána!",
  friendInvitation: "Pozvánka k přátelství",
  sendFriendRequest: "Poslat žádost o přátelství",
  loginToSendFriendRequest: "Pro odeslání žádosti o přátelství se přihlaste",
  chooseLanguage: "Vyberte jazyk",
  invalidCredentials: "Neplatné přihlašovací údaje. Zkuste to znovu.",
  username: "Uživatelské jméno",
  password: "Heslo",
  forgotPasswordQuestion: "Zapomněli jste heslo?",
  dontHaveAccount: "Nemáte účet?",
  registerHere: "Zaregistrujte se zde",
  invalidProfilePhotoType: "Neplatný typ souboru. Nahrajte obrázek JPEG, PNG, GIF nebo WebP.",
  invalidFileExtension: "Neplatná přípona souboru",
  allowedExtensions: "Povoleno",
  fileTooLarge: "Soubor je příliš velký",
  maximumFileSize: "Maximum",
  profilePhotoRemoved: "Profilová fotografie byla odstraněna.",
  failedToRemoveProfilePhoto: "Nepodařilo se odstranit profilovou fotografii",
  profileUpdatedSuccessfully: "Profil byl úspěšně aktualizován!",
  failedToUpdateProfile: "Nepodařilo se aktualizovat profil",
  privateEmailExplanation: "Váš e-mail vidíte pouze vy, aby se zabránilo nevyžádaným zprávám mimo platformu",
  yourEmailIsPrivate: "Váš e-mail je soukromý.",
  profilePhoto: "Profilová fotografie",
  removePhoto: "Odstranit fotografii",
  firstName: "Jméno",
  lastName: "Příjmení",
  tellPeopleAboutYourself: "Řekněte o sobě ostatním",
  whereToContactMe: "Jak mě kontaktovat",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Uložit",
  notSet: "Nenastaveno",
  editProfile: "Upravit profil",
  imageToCrop: "Obrázek k oříznutí",
  zoom: "Přiblížení",
  usePhoto: "Použít fotografii",
  name: "Jméno",
  whereToContact: "Kontakt",
  removeFriendship: "Odstranit přátelství",
  confirmRemoveFriend: "Potvrdit odstranění přítele",
  confirmRemoveFriendBefore: "Opravdu chcete odstranit",
  confirmRemoveFriendAfter: "ze svého seznamu přátel?",
  friendRemoved: "Přítel byl odstraněn.",
  failedToRemoveFriend: "Nepodařilo se odstranit přítele.",
  confirmRemove: "Potvrdit odstranění",
  error: "Chyba",
  removed: "Odstraněno",
  passwordsDoNotMatch: "Hesla se neshodují",
  registrationFailed: "Registrace se nezdařila. Zkuste to znovu.",
  confirmPassword: "Potvrdit heslo",
  alreadyHaveAccount: "Již máte účet?",
  loginHere: "Přihlaste se zde",
  passwordResetSuccessfully: "Heslo bylo úspěšně obnoveno.",
  failedToResetPassword: "Nepodařilo se obnovit heslo.",
  resetPassword: "Obnovit heslo",
  newPassword: "Nové heslo",
  confirmNewPassword: "Potvrdit nové heslo",
  setNewPassword: "Nastavit nové heslo",
  emailVerifiedSuccessfully: "E-mail byl úspěšně ověřen!",
  emailVerificationFailed: "Ověření se nezdařilo. Odkaz může být neplatný nebo vypršel.",
  verifying: "Ověřování...",
  verified: "Ověřeno!",
  redirectingToHome: "Přesměrování na domovskou stránku...",
  verificationFailed: "Ověření selhalo",
  goToHome: "Přejít domů",
  about: "O aplikaci",
  aboutConceptTitle: "Koncept",
  aboutCreatorIntroduction: "Ahoj, jsem Crypt0, lezec a tvůrce Run Into Me.",
  aboutCreatorStory: "Tento web jsem vytvořil, protože rád komunikuji s dalšími lezci a plánování společných akcí mi zabíralo příliš času.",
  aboutPlanningProblem: "Chtěl jsem všem najednou oznámit, kdy a kde budu lézt, bez formální pozvánky.",
  aboutDeveloperSolution: "Pak jsem si uvědomil, že jsem vývojář a mohu řešení vytvořit sám.",
  aboutWelcome: "Vítejte v Run Into Me, kde přátelům oznámíte aktivity, ke kterým se mohou nezávazně přidat.",
  aboutCallToAction: "Příští aktivitu, která je zábavnější společně, zveřejněte zde!",
  aboutTutorialTitle: "Návod",
  aboutCalendarCreateEvent: "Na obrazovce Kalendář můžete také vytvořit novou událost.",
  aboutEventColorsIntroduction: "Barvy označují stav účasti:",
  aboutColorGold: "Zlatá",
  aboutColorGoldDescription: "Událost pořádáte.",
  aboutColorGreen: "Zelená",
  aboutColorGreenDescription: "Události se zúčastníte.",
  aboutColorOrange: "Oranžová",
  aboutColorOrangeDescription: "Odpověděli jste „možná“.",
  aboutColorBlue: "Modrá",
  aboutColorBlueDescription: "Zatím jste neodpověděli.",
  aboutColorGray: "Šedá",
  aboutColorGrayDescription: "Pozvánku jste odmítli.",
  aboutCalendarEventDetails: "Kliknutím zobrazíte podrobnosti a můžete odpovědět.",
  aboutFriendPageTitle: "Stránka přátel",
  aboutFriendPageDescription: "Zadejte uživatelské jméno nebo odešlete odkaz / QR kód.",
  aboutHomePageTitle: "Domovská stránka",
  aboutHomePageDescription: "Procházejte události přátel a oznamte účast.",
  aboutRepostScreenTitle: "Obrazovka sdílení",
  aboutGoogleCalendarDescription: "Tímto tlačítkem přidáte událost do Kalendáře Google.",
  aboutRepostDescription: "Po potvrzení účasti můžete událost sdílet přátelům.",
};

export default cs;